<div class="main">
  <div class="main__container">
    @if (!showProject) {
    <agenda-customer-ui-maintenance-page />
    } @else {
    <agenda-customer-ui-status-dashboard />
    }
  </div>
</div>
